<template>
  <modal @close="$emit('close')">
    <template #title>
      Emitir notas do mês
    </template>
    <template #body>
      <div v-if="preview">
        <template v-if="!summary">
          <p class="emit-month-modal__requested">
            {{ preview.requested.length }} nota(s) a pedir, total {{ preview.requested_total | formatCurrency }}
          </p>
          <p class="emit-month-modal__skipped">
            {{ preview.skipped.length }} já tem nota pedida
          </p>
          <p class="emit-month-modal__ineligible">
            {{ preview.ineligible.length }} inelegível(is)
          </p>
          <ul class="emit-month-modal__ineligible-reasons">
            <li v-for="item in preview.ineligible" :key="item.fee_closing_id">
              {{ formatCnpj(item.tomador_document) }}: {{ item.reason }}
            </li>
          </ul>
        </template>
        <p v-else class="emit-month-modal__summary">
          {{ summary.requested.length }} nota(s) pedida(s), total {{ summary.requested_total | formatCurrency }}
        </p>
      </div>
    </template>
    <template #footer>
      <button v-if="preview && !summary" class="emit-month-modal__confirm btn btn-primary" @click="confirm">
        Confirmar
      </button>
      <button class="emit-month-modal__close btn btn-default" @click="$emit('close')">
        Fechar
      </button>
    </template>
  </modal>
</template>

<script>
import FeeClosingsService from 'services/FeeClosingsService';
import Modal from 'components/Modal';
import { formatCnpj } from './labels';

export default {
  name: 'EmitMonthModal',
  components: {
    Modal,
  },
  props: {
    month: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      preview: null,
      summary: null,
    };
  },
  mounted() {
    this.$loader.show();
    FeeClosingsService.previewEmissions(this.month)
      .then((preview) => {
        this.preview = preview;
        this.$loader.hide();
      })
      .catch((error) => {
        this.$loader.hide();
        this.$alert.notifyAlert(error.response?.data?.message || 'Erro ao consultar a prévia de emissão.');
      });
  },
  methods: {
    formatCnpj,

    confirm() {
      this.$loader.show();
      FeeClosingsService.emitMonth(this.month)
        .then((summary) => {
          this.summary = summary;
          this.$loader.hide();
        })
        .catch((error) => {
          this.$loader.hide();
          this.$alert.notifyAlert(error.response?.data?.message || 'Erro ao emitir as notas do mês.');
        });
    },
  },
};
</script>
